module.exports = __webpack_public_path__ + "img/SketchPnge6bacfe2bd22d1671b35fc207c63bad2464737f7a28f4238036c472be6677f6f.1a7dd784.png";